<template>
  <section>
    <div v-if="!loading && !this.isMeetingMode">
      <ConfirmationStatus :bookings="bookings" />
    </div>

    <!-- Start Meeting Confirmation Page -->
    <div
      v-else-if="!loading"
      class="is-light wdt"
      style="width: 800px; max-width: 100%; margin: auto;"
    >
      <div class="columns content">
        <div class="column">
          <div
            v-html="meetingInfo.meeting.registrationCompleteMessage"
            class="margin: auto;"
          ></div>
        </div>
      </div>
      <h3 class="is-size-3 my-3 has-text-grey" style="text-align: center;">
        Meeting Registration Overview
      </h3>
      <b-tabs type="is-toggle" position="is-centered">
        <b-tab-item label="Attendee Details">
          <div class="box">
            <h3 class="is-size-4 mb-4 has-text-grey">Attendee Details</h3>

            <div class="columns is-mobile">
              <div class="column sect">
                <b-field label="First Name">
                  <b-input
                    v-model="$globals.currentTravellerProfile.firstName"
                    required
                    validation-message="Please enter a valid name"
                    pattern="[a-zA-Z]*"
                    disabled
                  ></b-input>
                </b-field>
                <b-field label="Middle Name (optional)">
                  <b-input
                    v-model="$globals.currentTravellerProfile.middleName"
                    validation-message="Please enter a valid name"
                    pattern="[a-zA-Z]*"
                    disabled
                  ></b-input>
                </b-field>
                <b-field label="Last Name">
                  <b-input
                    v-model="$globals.currentTravellerProfile.lastName"
                    required
                    validation-message="Please enter a valid name"
                    pattern="[a-zA-Z]*"
                    disabled
                  ></b-input>
                </b-field>
                <b-field label="Date of Birth">
                  <b-input
                    v-model="$globals.currentTravellerProfile.dateOfBirth"
                    placeholder="yyyy-mm-dd"
                    required
                    disabled
                  ></b-input>
                </b-field>
                <b-field label="Gender">
                  <b-select
                    v-model="$globals.currentTravellerProfile.gender"
                    placeholder="Select Gender"
                    expanded
                    disabled
                  >
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Non-Binary">Non-Binary</option>
                  </b-select>
                </b-field>
                <b-field label="Mobile Phone">
                  <b-input
                    v-model="$globals.currentTravellerProfile.mobilePhone"
                    required
                    disabled
                  ></b-input>
                </b-field>
                <b-field label="Email">
                  <b-input
                    v-model="$globals.currentTravellerProfile.email"
                    type="email"
                    disabled
                  ></b-input>
                </b-field>
                <b-field label="TSA PreCheck™ Number (optional)">
                  <b-input
                    v-model="$globals.currentTravellerProfile.tsaPrecheckNumber"
                    disabled
                  ></b-input>
                </b-field>
              </div>
            </div>
            <div
              class="buttons has-addons"
              style="text-align: center; margin: auto;"
            >
              <a
                @click="$router.push({ path: '/meetings/attendee-details' })"
                class="is-size-7 button"
                style="text-align: center;margin : auto;"
                >Edit attendee info</a
              >
            </div>
          </div>
        </b-tab-item>

        <b-tab-item
          label="Survey Responses"
          v-if="meetingInfo.meeting.registrationSurveyId"
        >
          <div class="box">
            <h3 class="is-size-4 mb-4 has-text-grey">Survey Responses</h3>

            <div class="columns is-mobile">
              <div class="column sect">
                <div
                  v-for="(component, index) in survey.components"
                  :key="index"
                >
                  <!-- {{component}} -->
                  <b-field :label="component.label">
                    <img
                      v-if="component.type == 'signature'"
                      :src="getQuestionResponse(component.questionId).answer"
                    />
                    <b-input
                      v-else
                      :value="getQuestionResponse(component.questionId).answer"
                      disabled
                    ></b-input>
                  </b-field>
                </div>
              </div>
            </div>
            <div
              class="buttons has-addons"
              style="text-align: center; margin: auto;"
            >
              <a
                type="is-gant"
                @click="$router.push({ path: '/meetings/survey' })"
                class="is-size-7 teal-text button"
                style="text-align: center;margin : auto;"
                >Edit survey response</a
              >
            </div>
          </div>
        </b-tab-item>

        <b-tab-item label="My Trip">
          <div class="has-background-light">
            <h3 class="is-size-4 mb-4 has-text-grey">Your Trip</h3>

            <div class="columns is-mobile">
              <div class="column sect">
                <div style="text-align: center;">
                  <ConfirmationStatus :bookings="bookings" />
                </div>

                <TripDetail
                  v-if="pnr_exists"
                  :recordLocatorHash="encryptedRecordLocator"
                  :source="isMeetingMode ? 'MEETING_MODE' : ''"
                />

              </div>
            </div>

            <div
              v-if="!pnr_exists && bookings.length == 0"
              class="has-text-centered"
              style=""
            >
              <div>
                <p class="is-size-6 my-3" style="color: gray;">
                  There is no booking associated with this meeting. Click below
                  to add meeting travel.
                </p>
              </div>

              <b-button
                type="is-primary"
                @click="bookingRouter"
                class=""
                style=""
                outlined
                >Add a booking</b-button
              >

            </div>
          </div>
        </b-tab-item>
      </b-tabs>
    </div>

    <div v-else>
      <b-loading
        :is-full-page="false"
        :active="loading"
        :can-cancel="true"
      ></b-loading>
    </div>
    <br />
  </section>
</template>

<script>
import TripDetail from "../views/TripDetail";
import meetingsMixin from "../mixins/meetingsMixin";
import ConfirmationStatus from "@/components/Itinerary/ConfirmationStatus.vue";

export default {
  name: "Pnr",
  mixins: [meetingsMixin],
  components: {
    TripDetail,
    ConfirmationStatus,
  },
  data: function() {
    return {
      meetingTrip: {},
      survey: {},
      questionResponses: [],
      surveyLoaded: false,
      responsesLoaded: false,
      tripLoaded: false,
    };
  },
  computed: {
    loading() {
      if (this.isMeetingMode) {
        return false;
        //console.log(this.responsesLoaded, this.tripLoaded, this.surveyLoaded)
        // return !(this.responsesLoaded && this.tripLoaded && this.surveyLoaded);
      }
      return this.tripLoaded;
    },
    bookings() {
      return this.$store.state.pnr.status;
    },
    pnr_exists() {
      return this.meetingInfo?.pnrRecordLocator ? true : false;
    },
    pnr_locator() {
      if (this.meetingInfo?.pnrRecordLocator) {
        return this.meetingInfo.pnrRecordLocator;
      }

      return null;
    },
    encryptedRecordLocator() {
      if (this.pnr_locator) {
        return this.$helpers.encryptText(this.pnr_locator);
      } else {
        return null;
      }
    },
    /*
    pnr_info() {
      if (this.bookings.length > 0) {
        return this.bookings[0].trip;
      } else if (this.meetingInfo?.pnrRecordLocator) {
        return this.meetingTrip;
      } else {
        return {};
      }
    },
    */
  },
  methods: {
    bookingRouter() {
      this.$store.dispatch("meetings/optOutHotel", false);
      this.$store.dispatch("meetings/optOutCar", false);
      this.$store.dispatch("meetings/optOutFlight", false);
      if (this.meetingInfo.noAirTravelRequired) {
        this.$router.push({ path: "/meetings/hotels" });
      } else {
        this.$router.push({ path: "/meetings/flights" });
      }
    },
    search() {
      this.$router.push({ path: "/search" });
    },
    async getTrip(pnr) {
      var raw = {
        meta: {
          stateful: false,
          sessionKey: null,
          normalizeResponse: true,
        },
        recordLocator: pnr,
        // "recordLocator": "2J85YK"
      };
      // console.log(JSON.stringify(raw))
      this.$app
        .huddleLabsServerCall("amadeus/trips/show", raw)
        .then((result) => {
          this.meetingTrip = result.data;
          this.tripLoaded = true;
        });
    },
    loadSurvey() {
      var body = {
        id: this.meetingInfo.meeting.registrationSurveyId,
      };

      this.$app
        .huddleLabsServerCall("meetings/survey/show", body)
        .then((result) => {
          // console.log(result);

          if (result && result.data) {
            this.survey = result.data;
            this.surveyLoaded = true;
          } else {
            this.survey = null;
          }
        })
        .catch((error) => {
          // console.log('error', error)

          this.$buefy.toast.open({
            message:
              "Something went wrong while loading the registration questions. Please try to reload this page.",
            type: "is-danger",
          });
        });
    },
    loadExistingResponses() {
      var body = {
        surveyId: this.meetingInfo.meeting.registrationSurveyId,
        attendeeId: this.meetingInfo.attendeeId,
      };

      this.$app
        .huddleLabsServerCall("meetings/survey-response/show", body)
        .then((result) => {
          // console.log(result);

          if (result && result.data && result.data.responses) {
            this.questionResponses = result.data.responses;
            this.responsesLoaded = true;
          } else {
            this.questionResponses = [];
          }
        })
        .catch((error) => {
          // console.log('error', error)

          this.$buefy.toast.open({
            message:
              "Something went wrong while loading your registration responses. Please try to reload this page.",
            type: "is-danger",
          });
        });
    },
    getQuestionResponse(questionId) {
      // Find the matching response for this question
      let items = this.questionResponses.filter(function(resp) {
        return resp.questionId == questionId;
      });

      // Create a response with an empty answer if an existing one not found
      if (items.length != 1) {
        return {
          questionId: questionId,
          answer: null,
        };
      }

      // Return the matching response
      return items[0];
    },
  },
  mounted() {
    this.$store.dispatch("bookTravel/setBooked", true);
    this.solution = this.$store.state.bookTravel.result;
    this.$store.commit("clearState/CLEAR_DETAILS");

    if (this.isMeetingMode) {
      /*
      if (this.pnr_exists) {
        if (!this.$store.state.pnr.info) {
          this.getTrip(this.pnr_locator);
        }
      } else {
        this.tripLoaded = true;
      }*/

      if (this.meetingInfo.meeting.registrationSurveyId) {
        this.loadSurvey();
        this.loadExistingResponses();
      } else {
        this.questionsLoaded = true;
        this.responsesLoaded = true;
        this.surveyLoaded = true;
      }
    } else {
      this.questionsLoaded = true;
      this.responsesLoaded = true;
      this.surveyLoaded = true;
    }
  },
};
</script>

<style>
.lds-default {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.lds-default div {
  position: absolute;
  width: 6px;
  height: 6px;
  background: #dfc;
  border-radius: 50%;
  animation: lds-default 1.2s linear infinite;
}

.lds-default div:nth-child(1) {
  animation-delay: 0s;
  top: 37px;
  left: 66px;
}

.lds-default div:nth-child(2) {
  animation-delay: -0.1s;
  top: 22px;
  left: 62px;
}

.lds-default div:nth-child(3) {
  animation-delay: -0.2s;
  top: 11px;
  left: 52px;
}

.lds-default div:nth-child(4) {
  animation-delay: -0.3s;
  top: 7px;
  left: 37px;
}

.lds-default div:nth-child(5) {
  animation-delay: -0.4s;
  top: 11px;
  left: 22px;
}

.lds-default div:nth-child(6) {
  animation-delay: -0.5s;
  top: 22px;
  left: 11px;
}

.lds-default div:nth-child(7) {
  animation-delay: -0.6s;
  top: 37px;
  left: 7px;
}

.lds-default div:nth-child(8) {
  animation-delay: -0.7s;
  top: 52px;
  left: 11px;
}

.lds-default div:nth-child(9) {
  animation-delay: -0.8s;
  top: 62px;
  left: 22px;
}

.lds-default div:nth-child(10) {
  animation-delay: -0.9s;
  top: 66px;
  left: 37px;
}

.lds-default div:nth-child(11) {
  animation-delay: -1s;
  top: 62px;
  left: 52px;
}

.lds-default div:nth-child(12) {
  animation-delay: -1.1s;
  top: 52px;
  left: 62px;
}

@keyframes lds-default {
  0%,
  20%,
  80%,
  100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.5);
  }
}
</style>
